<!-- Responsibility: Present invitee reality choices on the welcome surface.
Scope: Resume and curated reality selection only; launch orchestration lives in the owning screen. -->
<welcome-reality-selector>
  <section class="reality-selector">
    <header class="section-head">
      <p class="eyebrow">REALITY SELECTOR</p>
      <h3>Resume the last game, or launch a curated reality.</h3>
      <p>Invitees should not have to hunt. The save archive comes first, then the published realities below.</p>
    </header>

    <button type="button" class="resume-game-btn" onclick={ resumeGame }>
      <span class="resume-kicker">RESUME GAME</span>
      <strong>Open the save archive</strong>
      <small>Return to the exact live scenario you left behind.</small>
    </button>

    <div class="reality-list" aria-label="Curated realities">
      <button
        each={ offer in offers }
        type="button"
        class="reality-card-btn"
        disabled={ isBusy(offer) }
        onclick={ () => startOffer(offer) }
      >
        <strong>{ offer.title }</strong>
        <span>{ offer.summary || offer.worldManifestId }</span>
        <small>{ offer.kind.toUpperCase() } · { offer.starterCode ? 'starter bundle' : 'world bundle' }</small>
        <em>{ isBusy(offer) ? 'STARTING...' : 'PLAY THIS REALITY' }</em>
      </button>
    </div>

    <p if={ !offers.length } class="welcome-note">No curated reality is published yet. Check back after the admin preforge capture runs.</p>
  </section>

  <script>
    export default {
      get offers() {
        return Array.isArray(this.props.offers) ? this.props.offers : []
      },

      isBusy(offer) {
        return String(this.props.busy ?? '') === String(offer?.id ?? '')
      },

      resumeGame() {
        this.props.actions?.resumeGame?.()
      },

      startOffer(offer) {
        if (!offer || this.isBusy(offer)) return
        this.props.actions?.selectOffer?.(offer)
      },
    }
  </script>

  <style>
    welcome-reality-selector {
      display: block;
    }

    welcome-reality-selector .reality-selector {
      display: grid;
      gap: var(--space-sm);
      padding: var(--space-lg);
      border: 1px solid color-mix(in srgb, var(--border) 52%, transparent);
      border-radius: var(--radius-lg);
      background:
        radial-gradient(circle at top right, color-mix(in srgb, var(--gold) 10%, transparent), transparent 28%),
        color-mix(in srgb, var(--surface) 78%, transparent);
      box-shadow: inset 0 1px 0 color-mix(in srgb, var(--text-prose) 10%, transparent);
    }

    welcome-reality-selector .section-head {
      display: grid;
      gap: var(--space-xs);
    }

    welcome-reality-selector .eyebrow {
      margin: 0;
      color: var(--gold);
      font-size: var(--type-xs);
      letter-spacing: 0.18em;
      text-transform: uppercase;
    }

    welcome-reality-selector h3 {
      margin: 0;
      color: var(--text-prose);
      font-size: var(--type-lg);
      line-height: 1.12;
    }

    welcome-reality-selector .section-head p,
    welcome-reality-selector .welcome-note {
      margin: 0;
      color: var(--text-dim);
      line-height: 1.55;
    }

    welcome-reality-selector .resume-game-btn,
    welcome-reality-selector .reality-card-btn {
      display: grid;
      gap: 0.2rem;
      width: 100%;
      padding: var(--space-md);
      border: 1px solid color-mix(in srgb, var(--border) 52%, transparent);
      border-radius: var(--radius-md);
      background: color-mix(in srgb, var(--bg) 66%, transparent);
      color: inherit;
      text-align: left;
      cursor: pointer;
      transition: transform var(--motion-fast) ease, border-color var(--motion-fast) ease;
    }

    welcome-reality-selector .resume-game-btn {
      border-color: color-mix(in srgb, var(--sem-success-fg) 36%, var(--border));
      background:
        radial-gradient(circle at top right, color-mix(in srgb, var(--sem-success-fg) 14%, transparent), transparent 40%),
        color-mix(in srgb, var(--bg) 62%, transparent);
    }

    welcome-reality-selector .resume-kicker {
      color: var(--sem-success-fg);
      font-size: var(--type-xs);
      letter-spacing: 0.16em;
      text-transform: uppercase;
    }

    welcome-reality-selector .resume-game-btn strong,
    welcome-reality-selector .reality-card-btn strong {
      color: var(--text-prose);
      font-size: var(--type-md);
    }

    welcome-reality-selector .resume-game-btn small,
    welcome-reality-selector .reality-card-btn span,
    welcome-reality-selector .reality-card-btn small,
    welcome-reality-selector .reality-card-btn em {
      color: var(--text-dim);
      font-style: normal;
      font-size: var(--type-sm);
      line-height: 1.45;
    }

    welcome-reality-selector .reality-list {
      display: grid;
      gap: var(--space-sm);
    }

    welcome-reality-selector .reality-card-btn em {
      color: var(--gold);
      margin-top: var(--space-xs);
    }

    welcome-reality-selector .resume-game-btn:hover:not(:disabled),
    welcome-reality-selector .reality-card-btn:hover:not(:disabled),
    welcome-reality-selector .resume-game-btn:focus-visible:not(:disabled),
    welcome-reality-selector .reality-card-btn:focus-visible:not(:disabled) {
      outline: none;
      transform: translateY(-0.075rem);
      border-color: color-mix(in srgb, var(--gold) 42%, var(--border));
    }

    welcome-reality-selector .reality-card-btn:disabled {
      cursor: progress;
      opacity: 0.82;
    }
  </style>
</welcome-reality-selector>
